import { derived } from "svelte/store"
import { page } from "$app/stores"

export const screenshotMode = derived(
    page,
    ($page) => $page.url.searchParams.get("screenshot") === "1",
)
